import ErrorUtils from '~/utils/error_utils';

export default {
    getFeatureFlags(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/feature-flags/get-flags',
                method: 'GET',
                data: payload,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to fetch feature flags', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },
};
